import { useEffect, useState } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen bg-gradient-to-b from-[#0A1628] to-[#2D1B69] overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/ac2bf498-12b5-498b-9e32-1502a6e3dca0.png" 
              alt="JANI d.o.o. logo" 
              title="JANI d.o.o. - iOS App Development"
              className="h-10 w-10 object-contain"
            />
            <h1 className={`text-lg font-light tracking-wide transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              JANI d.o.o.
            </h1>
          </div>
          <div className="flex items-center gap-8">
            {['home', 'about', 'products', 'features', 'contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`text-sm font-medium capitalize transition-colors hover:opacity-80 whitespace-nowrap ${
                  scrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-40 pb-32">
        <div className="max-w-2xl">
          <h2 className="text-7xl font-medium text-white leading-tight mb-10" style={{ lineHeight: '1.1' }}>
            Crafting Premium iOS Experiences
          </h2>
          <p className="text-xl text-white/70 max-w-lg leading-relaxed">
            VPN & Cleaner solutions engineered for modern mobile security
          </p>
        </div>
      </div>

      {/* Floating Geometric Shapes */}
      <div className="absolute bottom-24 right-20 w-96 h-96 pointer-events-none">
        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-3xl transform rotate-12 backdrop-blur-sm"></div>
        <div className="absolute bottom-0 right-12 w-56 h-56 bg-gradient-to-br from-blue-500/20 to-purple-600/20 rounded-3xl transform -rotate-6 backdrop-blur-sm"></div>
        <div className="absolute top-20 right-32 w-48 h-48 bg-gradient-to-br from-purple-600/20 to-blue-400/20 rounded-3xl transform rotate-45 backdrop-blur-sm"></div>
      </div>
    </section>
  );
}
